import { createApp } from 'vue'
import PersonalFundraisingActiveCard from './PersonalFundraisingActiveCard'

const el = '.kb-component--personal-fundraising-active-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((cardDOM) => {
            const name = cardDOM.dataset.name || ''
            const url = cardDOM.dataset.url || null
            const editUrl = cardDOM.dataset.editUrl || null
            const amount = Number(cardDOM.dataset.amount) || 0
            const targetAmount = Number(cardDOM.dataset.targetAmount) || 0
            const editLabel = cardDOM.dataset.editLabel || 'Rediger indsamling'
            const remainingLabelTemplate =
                cardDOM.dataset.remainingLabelTemplate ||
                'Du er {amount} fra at nå dit mål'
            const shareSubtext =
                cardDOM.dataset.shareSubtext ||
                'Del igen og kom tættere på målet'
            const linkCopiedLabel =
                cardDOM.dataset.linkCopiedLabel || 'Dit link er kopieret!'

            const component = createApp(PersonalFundraisingActiveCard, {
                name,
                url,
                editUrl,
                amount,
                targetAmount,
                editLabel,
                remainingLabelTemplate,
                shareSubtext,
                linkCopiedLabel
            }).use(Store)
            component.mount(cardDOM)
        })
    }
}
